<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    centered
  >
    <div class="text-black text-center mb-2">
      <b-row class="justify-content-center mb-1 pt-1">
        <img
          src="https://storage.googleapis.com/komerce/assets/svg/Icon-Error.svg"
          alt="icon-error"
        >
      </b-row>
      <div class="mb-1 pt-1">
        <h4 class="font-bold text-black">
          {{ modalTitle }}
        </h4>
      </div>
      <div class="mb-2">
        <p class="text-[#828282]">
          {{ modalDescription }}
        </p>
      </div>
      <b-button
        block
        variant="primary"
        @click="handleClickAction"
      >
        {{ modalButtonText }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BRow, BButton } from 'bootstrap-vue'

export default {
  name: 'ModalMaxPin',
  components: {
    BModal,
    BRow,
    BButton,
  },
  props: {
    id: {
      type: String,
      default: 'max-chance-PIN',
    },
    type: {
      type: String,
      default: 'pin',
    },
  },
  computed: {
    modalTitle() {
      return this.type === 'password'
        ? 'Kamu sudah salah password 5x'
        : 'Kamu sudah salah input PIN 3x'
    },
    modalDescription() {
      return this.type === 'password'
        ? 'Silakan coba lagi dalam 24 jam sejak terakhir salah password'
        : 'Silakan coba lagi dalam 24 jam sejak terakhir salah input PIN'
    },
    modalButtonText() {
      return this.type === 'password' ? 'Lupa Password' : 'Lupa PIN'
    },
  },
  methods: {
    handleClickAction() {
      this.$bvModal.hide(this.id)

      if (this.type === 'password') {
        // Jika type password
        this.$router.push({ name: 'auth-forgot-password' })
      } else {
        // Jika type pin
        const currentRoute = this.$route.name
        if (currentRoute === 'pin') {
          this.$bvModal.show('modal-forgot-pin')
        } else {
          this.$router.push({ name: 'pin' })
        }
      }
    },
  },
}
</script>
